import { ensureOwnership, getDb } from "./DbService";

export const JourneyMetaService = {
  async getLastFetchAt(key: string): Promise<number | null> {
    await ensureOwnership();
    const db = getDb();
    const entry = await db.meta.get(key);
    return entry?.lastFetchAt ?? null;
  },

  async isStale(key: string, ttlMs: number): Promise<boolean> {
    if (ttlMs === 0) {
      return true;
    }
    const last = await this.getLastFetchAt(key);
    if (last === null) {
      return true;
    }
    return Date.now() - last >= ttlMs;
  },

  async invalidate(key: string): Promise<void> {
    await ensureOwnership();
    const db = getDb();
    await db.meta.delete(key);
  }
};
